import { createSafeProps } from 'src/lib/tcs-app-insights/app-insights-util';
import { Logger, LogMessage } from 'pubnub';
import { NewRelicLogger } from '../../tcs-logging/new-relic-logger';
import { LoggerOptionsService } from '../../tcs-logging/logger-options.service';
import { parsePubnubLog } from '../pubnub-config';

export class PubnubNewRelicLogger implements Logger {
  constructor(private _logger: NewRelicLogger, private _loggerSettings: LoggerOptionsService) {}

  public error(log: LogMessage): void {
    if (this._loggerSettings.isPubnubLoggingEnabled()) {
      const { message, sanitizedLog } = parsePubnubLog(log);
      const safeLog = createSafeProps({ pubnub: sanitizedLog });
      this._logger.error(`PubnubNewRelicLogger Error: ${message}`, safeLog);
    }
  }

  public warn(log: LogMessage): void {
    if (this._loggerSettings.isPubnubLoggingEnabled()) {
      const { message, sanitizedLog } = parsePubnubLog(log);
      const safeLog = createSafeProps({ pubnub: sanitizedLog });
      this._logger.warning(`PubnubNewRelicLogger Warning: ${message}`, safeLog);
    }
  }

  public info(log: LogMessage): void {
    if (this._loggerSettings.isPubnubLoggingEnabled()) {
      const { message, sanitizedLog } = parsePubnubLog(log);
      const safeLog = createSafeProps({ pubnub: sanitizedLog });
      this._logger.info(`PubnubNewRelicLogger Info: ${message}`, safeLog);
    }
  }

  public debug(log: LogMessage): void {
    if (this._loggerSettings.isPubnubLoggingEnabled()) {
      const { message, sanitizedLog } = parsePubnubLog(log);
      const safeLog = createSafeProps({ pubnub: sanitizedLog });
      this._logger.info(`PubnubNewRelicLogger Debug: ${message}`, safeLog);
    }
  }

  public trace(log: LogMessage): void {
    if (this._loggerSettings.isPubnubLoggingEnabled()) {
      const { message, sanitizedLog } = parsePubnubLog(log);
      const safeLog = createSafeProps({ pubnub: sanitizedLog });
      this._logger.info(`PubnubNewRelicLogger Trace: ${message}`, safeLog);
    }
  }
}
